import { formInitialization } from "./form";

function handleForms() {
  const path = "/rs/349-JNN-804/images/marketo-xdframe-relative.html";
  MktoForms2.setOptions({
    formXDPath: path,
  });

  $(".marketo-form").each(function () {
    formInitialization($(this));
  });

  $(".default-base-form").each(function () {
    formInitialization($(this));
  });
}

export default handleForms;
